<div class="d-flex justify-content-between">
  <h1
    class="content-with-tabs-content-title mb-1 mb-sm-2 h1 grey-1 "
    [innerHTML]="_title"
    [ngClass]="{ 'content-with-tabs-content-title--no-subtitle': !_subtitle && !subtitleTemplate }"></h1>
</div>
<div class="grey-2 content-with-tabs-content-subtitle_sm" [innerHTML]="_subtitle" *ngIf="_subtitle && !subtitleTemplate"></div>
<ng-container [ngTemplateOutlet]="subtitleTemplate" *ngIf="subtitleTemplate"></ng-container>
<hr class="content-with-tabs-content-divider" *ngIf="!noDivider"/>
